import * as THREE from 'three'

import MathsUtils from '@/utils/mathsUtils'
import BaseObject from './baseObject'


// Shape Warning Icon Object
// Used to display warning status for panels
export default class ShapeWarningIconObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.persistable = false
    this.colour = options.colour || '#f8ac59'
    this.iconTexture = editor.resources.iconWarningTexture

    this.iconSize = options.iconSize || 32
    this.angle = 0
    this.position = new THREE.Vector2(0, 0)
    this.mouseHover = false

    this.iconGeometry = null
    this.iconObject = null
    
    this.listenMouseEvents = false

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()
  }

  // Dispose
  dispose() {
    super.dispose()

    if(this.iconGeometry) {
      this.iconGeometry.dispose()
      this.iconGeometry = null
    }
    this.iconObject = null

  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    let positionZ = 230
    var iconScale = 1.0 / this.editor.camera.zoom
    iconScale = Math.min(iconScale, 7.5)

    let angleRads = MathsUtils.degreesToRadians(this.angle)
    let objAngles = new THREE.Euler(0, 0, angleRads)

    if(this.iconObject) {
      // Offset right/down from position
      var iconOffset = 15 * iconScale
      
      this.iconObject.position.set(this.position.x + iconOffset, this.position.y + iconOffset, positionZ)
      this.iconObject.scale.set(-iconScale, -iconScale, 1)     // Flipped to adjust for texture

      this.iconObject.material.color.set(this.colour)
      this.iconObject.setRotationFromEuler(objAngles)
    }
  }


  // Update the position of the icon
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Update the rotation of the icon
  // Set in degrees
  setRotation(angle) {
    this.angle = angle
  }


  /**
   * Build the initial drawing objects to display the editing line
   */
  updateSceneObject() {
    this.clearSceneObject()

    this.iconGeometry = new THREE.BoxGeometry(this.iconSize, this.iconSize, 2.5)
    let objectMaterial = new THREE.MeshBasicMaterial({
      map: this.iconTexture,
      color: this.colour,
      transparent: true,
      opacity: 1.0,
      depthWrite: false,
      depthTest: false
    })

    this.iconObject = new THREE.Mesh(this.iconGeometry, objectMaterial)
    this.iconObject.scale.x = -1    // Flip around for the texture adjustment
    this.iconObject.scale.y = -1
    this.sceneObject.add(this.iconObject)
  }

}
